var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex container mx-auto mt-5 items-center justify-between flex-wrap md_flex-no-wrap text-center md_text-left px-3 md_px-1"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "text-4xl md_text-3xl text-brand-secondary-900 font-bold md_mb-3 w-full md_w-auto"
        },
        [_vm._v("Shop by Category")]
      ),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#dbebed",
          text: "Hobbies",
          route: {
            name: "marketplace",
            query: { category: "" + _vm.hobbiesCategory.id },
            params: { page: "1" }
          },
          image: _vm.mensCategoryImg
        }
      }),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#eddbe0",
          text: "Women's",
          route: {
            name: "marketplace",
            query: { product_type: "4" },
            params: { page: "1" }
          },
          image: _vm.womensCategoryImg
        }
      }),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#ededdb",
          text: "Kids",
          route: {
            name: "marketplace",
            query: { product_type: "9" },
            params: { page: "1" }
          },
          image: _vm.kidsCategoryImg
        }
      }),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#e4dbed",
          text: "T-shirts",
          route: {
            name: "marketplace",
            query: { product_type: "1" },
            params: { page: "1" }
          },
          image: _vm.tShirtsCategoryImg
        }
      }),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#e4e6e7",
          text: "Hoodies",
          route: {
            name: "marketplace",
            query: { product_type: "3" },
            params: { page: "1" }
          },
          image: _vm.hoodiesCategoryImg
        }
      }),
      _c("shop-by-category-image", {
        attrs: {
          fill: "#dbeddb",
          text: "Accessories",
          route: {
            name: "marketplace",
            query: { product_type: "17" },
            params: { page: "1" }
          },
          image: _vm.accessoriesCategoryImg
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }